// Central date/time formatters. Every user-facing date in the app renders
// as M/D/YYYY per the manager's directive (no leading zeros, US-style).
// Internal formats (data-testid keys, form inputs, DB writes) still use
// yyyy-MM-dd and are NOT routed through this file.
import { format, parseISO, isValid } from "date-fns";

const toDate = (v) => {
  if (v == null || v === "") return null;
  if (v instanceof Date) return isValid(v) ? v : null;
  if (typeof v === "string") {
    try {
      const d = v.includes("T") ? new Date(v) : parseISO(v);
      return isValid(d) ? d : null;
    } catch { return null; }
  }
  return null;
};

/** "9/11/2026" — the canonical user-facing date format */
export const mdy = (v, fallback = "") => {
  const d = toDate(v); return d ? format(d, "M/d/yyyy") : (v ?? fallback);
};

/** "9/11/26" — compact variant for tight columns / print */
export const mdyShort = (v, fallback = "") => {
  const d = toDate(v); return d ? format(d, "M/d/yy") : (v ?? fallback);
};

/** "9/11" — month + day only, for contexts that already show the year */
export const md = (v, fallback = "") => {
  const d = toDate(v); return d ? format(d, "M/d") : (v ?? fallback);
};

/** "Fri 9/11/2026" — weekday prefix + full M/D/YYYY */
export const mdyDow = (v, fallback = "") => {
  const d = toDate(v); return d ? format(d, "EEE M/d/yyyy") : (v ?? fallback);
};

/** "Fri 9/11" — weekday + short date */
export const mdDow = (v, fallback = "") => {
  const d = toDate(v); return d ? format(d, "EEE M/d") : (v ?? fallback);
};

/** "9/11/2026, 3:45 PM" — date + time */
export const mdyTime = (v, fallback = "") => {
  const d = toDate(v); return d ? format(d, "M/d/yyyy, h:mm a") : (v ?? fallback);
};

/** "9/11, 3:45 PM" — short date + time (no year) */
export const mdTime = (v, fallback = "") => {
  const d = toDate(v); return d ? format(d, "M/d, h:mm a") : (v ?? fallback);
};

/** "Fri 9/11/2026, 3:45 PM" — full weekday + date + time */
export const mdyDowTime = (v, fallback = "") => {
  const d = toDate(v); return d ? format(d, "EEE M/d/yyyy, h:mm a") : (v ?? fallback);
};
